package horcrux.common

enum class Environment {
    PROD, PRE_PROD, DEV;

    fun isProd(): Boolean = this == PROD

    companion object {
        const val ENVIRONMENT_VARIABLE_NAME: String = "ENVIRONMENT"
        operator fun invoke(valueMaybe: String?): Environment = when (valueMaybe) {
            "PROD" -> PROD
            "PRE_PROD" -> PRE_PROD
            else -> DEV
        }
    }
}
